import React from 'react';
import { Info, Hourglass, Settings as SettingsIcon, Sparkles } from 'lucide-react';

export default function ModalHeader({
  name,
  setName,
  lengthLabel,
  totalDuration,
  onDraftAi,
}) {
  const invalid = !name.trim();
  return (
    <div className="px-4 md:px-6 pt-4 md:pt-5 pb-3 md:pb-4 flex flex-col lg:flex-row lg:items-start gap-3 lg:gap-4 border-b border-[#EEE9FB]">
      <div className="flex-1 min-w-0 pr-10 lg:pr-0">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name the interview (e.g. Account manager, Frontend developer)"
          className={`w-full px-3 md:px-4 py-2.5 md:py-3 rounded-xl border outline-none text-[14px] md:text-[15px] placeholder-[#9A93B0] bg-white focus:ring-2 focus:ring-[#5B4FE8]/30 ${
            invalid ? 'border-[#E88B8B]' : 'border-[#E5DEF9]'
          }`}
          data-testid="interview-name-input"
        />
        {invalid && <p className="text-[12px] text-[#C23B3B] mt-1 ml-1">Required</p>}
      </div>

      <div className="flex items-center gap-2 md:gap-3 pt-1 shrink-0 flex-wrap">
        {onDraftAi && (
          <button
            onClick={onDraftAi}
            data-testid="open-draft-ai-btn"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gradient-to-r from-[#5B4FE8] to-[#7A6BFF] text-white text-[12px] md:text-[12.5px] font-semibold shadow-sm hover:shadow-md transition-all"
          >
            <Sparkles size={12} />
            <span className="hidden sm:inline">Draft with AI</span>
            <span className="sm:hidden">AI</span>
          </button>
        )}
        <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11.5px] md:text-[12px] font-semibold ${lengthLabel.color}`}>
          <span className="truncate max-w-[170px] md:max-w-none">{lengthLabel.text}</span>
          <Info size={12} />
        </div>
        <div className="inline-flex items-center gap-1.5 text-[12.5px] md:text-[13px] text-[#3A3453]">
          <Hourglass size={14} className="text-[#5B4FE8]" />
          <span className="hidden sm:inline">Duration:</span> <span className="font-semibold">{totalDuration} min</span>
        </div>
        <div className="hidden md:block w-px h-5 bg-[#E5DEF9]" />
        <button className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[#5B4FE8] text-[13px] font-semibold hover:bg-[#F1ECFE]">
          <SettingsIcon size={14} />
          Settings
        </button>
      </div>
    </div>
  );
}
